// True if at least one sample in the batch actually has a value for at least
// one column in this group. Used to keep whole add-on panels (Turf Elite Plus
// tests like soil physical, saturated-paste extract, H3A, etc.) hidden when
// the batch didn't include that test, instead of rendering a table of dashes.
export function groupHasData(samples, columns) {
	return columns.some(c => samples.some(s => {
		const v = c.get(s);
		return v != null && v !== '';
	}));
}

// Single-getter counterpart to groupHasData(), for chart specs (one metric
// per chart, rather than one table with several metric columns).
export function hasChartData(samples, get) {
	return samples.some(s => {
		const v = get(s);
		return v != null && v !== '';
	});
}
